import React, { Component } from 'react';
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import { injectIntl } from 'react-intl';
import './DatePeriod-style.css';
import { FaCalendarAlt } from "react-icons/fa";

// react-intl gives "fr-FR" / "es-ES" / "en"; moment only knows the base tag.
const momentLocale = (intl) => String((intl && intl.locale) || 'en').slice(0, 2);

class DatePeriod extends Component {
    constructor(props) {
        super(props);
        // Per-instance locale: Utils resets the global moment locale to the
        // browser's, so the account language is applied on each moment object.
        const loc = momentLocale(props.intl);
        let format = "DD MMM YYYY";
        let actualDateObject = new Date();
        let actualDateMomentObject = moment(
            new Date(actualDateObject.getFullYear(), actualDateObject.getMonth(), actualDateObject.getDate()-1, 0, 0, 0, 0)
        ).locale(loc);

        this.state = {
            dateFormat: format,
            start: actualDateMomentObject,
            end: moment(actualDateMomentObject).add(2, "days").subtract(1, "seconds"),
            date: actualDateMomentObject.format(format), // is displayed in the input
            authorizeChangeDate: true,
            backgroundColorSelected: false
        }
    } 

    /** Called when the date selected is applied (user select a preselected range or click on apply after choosing a custom range) */
    setChanges = (event, picker) => { 
        this.setState({ authorizeChangeDate: true })
        this.handleEvent(event, picker) // update of the input
    }

    /** Called automatically when the user interact with the combobox (open, close...) */ 
    handleEvent = (event, picker) => { 
        let { dateFormat } = this.state;
        let loc = momentLocale(this.props.intl);
        let dateText = "";
        let begin = moment(new Date(picker.startDate)).locale(loc).format(dateFormat);
        let end = moment(new Date(picker.endDate)).locale(loc).format(dateFormat);
        let pickerEndDate;
        let arrayDate = [];
        this.setState({backgroundColorSelected: !this.state.backgroundColorSelected})
        if (begin === end) { //if the user double-clicks on a date
            dateText = begin;
        } else { //if he selects 2 different dates for the range
            dateText = begin + " - " + end;
        }

        arrayDate.push(new Date(picker.startDate));
        pickerEndDate = new Date(picker.endDate)
        arrayDate.push(new Date(pickerEndDate.getFullYear(), pickerEndDate.getMonth(), pickerEndDate.getDate(), 23, 59, 59, 999));        

        if (this.state.authorizeChangeDate) {
            this.setState({ date: dateText, authorizeChangeDate: false }) // update of the input, the chosen date range is displayed
            this.props.getDate(arrayDate) // the range is send to the Calendar for it to display the range too
        }
    }

    /** The picker labels: the preset ranges plus the strings the widget itself
     *  renders ("Custom Range", Apply, Cancel), which default to English. */
    pickerLabels = () => {
        const intl = this.props.intl;
        const tr = (id, def) => (intl ? intl.formatMessage({ id, defaultMessage: def }) : def);
        return {
            today: tr('daterange.today', "Aujourd'hui"),
            customRange: tr('daterange.customRange', 'Période personnalisée'),
            apply: tr('daterange.apply', 'Appliquer'),
            cancel: tr('button.cancel', 'Annuler'),
        };
    }

    componentDidUpdate(prevProps) {
        const previous = momentLocale(prevProps.intl);
        const current = momentLocale(this.props.intl);
        if (previous !== current) {
            this.setState({ date: moment(this.state.start).locale(current).format(this.state.dateFormat) });
        }
    }

    render() {
        let { start, end, date } = this.state;
        const maxDateValue = new Date();
        const labels = this.pickerLabels();
        const localeData = moment.localeData(momentLocale(this.props.intl));
        const lastDays = (n) => (this.props.intl
            ? this.props.intl.formatMessage({ id: 'daterange.lastDays', defaultMessage: '{n} derniers jours' }, { n })
            : n + ' derniers jours');

        return (
            <DateRangePicker
                // initialSettings is only read when the picker is created, so a
                // language change has to remount it for the new labels to apply.
                key={momentLocale(this.props.intl)}
                initialSettings={{ 
                    startDate: start.toDate(),
                    endDate: end.toDate(),                    
                    showDropdowns: true,
                    maxDate: maxDateValue,

                    ranges: {
                        [labels.today]: [moment().toDate(), moment().toDate()],
                        [lastDays(2)]: [
                            moment().subtract(1, 'days').toDate(),
                            moment().toDate(),
                        ],
                        [lastDays(3)]: [
                            moment().subtract(2, 'days').toDate(),
                            moment().toDate(),
                        ],
                        [lastDays(7)]: [
                            moment().subtract(6, 'days').toDate(),
                            moment().toDate(),
                        ],
                        [lastDays(30)]: [
                            moment().subtract(29, 'days').toDate(),
                            moment().toDate(),
                        ],
                    },

                    // "Custom Range", Apply and Cancel default to English, and the
                    // calendar's day/month names to the global moment locale; both
                    // are pinned to the account language here.
                    locale: {
                        format: "DD-MM-YYYY HH:mm",
                        customRangeLabel: labels.customRange,
                        applyLabel: labels.apply,
                        cancelLabel: labels.cancel,
                        daysOfWeek: localeData.weekdaysMin(),
                        monthNames: localeData.monthsShort(),
                        firstDay: localeData.firstDayOfWeek(),
                    }
                }}
                onShow={this.setAuthorize}
                onEvent={this.handleEvent}
                applyCallback={this.applyCallback}
                onApply={this.setChanges}
                autoUpdateInput={false}
            >
                {this.props.screenSize.width !== undefined && this.props.screenSize.width > 600 ?
          <input
            readOnly
            value={date}
			style={this.props.compact
                ? { width: "110px", padding: "4px 6px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.8em", backgroundColor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", cursor: "pointer", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }
                : { maxWidth: "60%", minWidth: "220px", marginTop:"2%", padding: "6px 12px", borderRadius: "8px", border: "1px solid #ccc", fontSize: "0.95em", backgroundColor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", cursor: "pointer" }}
          />
                    :
                    <button style={{backgroundColor:(this.state.backgroundColorSelected === true ? "#30677F" : "white"), borderRadius: "5px", border: "1px solid grey", fontSize: "1.2em", marginRight:"5%"}}>
                        <FaCalendarAlt />
                    </button>
                }
            </DateRangePicker>
        )
    }
}
export default injectIntl(DatePeriod);